export default __webpack_public_path__ + "static/media/MedhaKudaisya.6bc957b2.png";